import { createContext } from 'react';

const valueContext = createContext();

export default valueContext;
